module.exports = __webpack_public_path__ + "static/media/hero.9dcc51f5.png";